export const TableinElementIds = {
  header: 'tablein-header',
};
